import ParkingCard from '@components/ParkingCard/ParkingCard.component'
import { useAuth } from '@context/AuthContext/AuthContext'
import { DateTime } from 'luxon'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Countdown, SpecificCarpayCard } from '../CarpayOrderCard.component'
import { CardExtraInfo } from '../CarpayOrderCard.style'
import CarpayOrderCardContent from '../CarpayOrderCardContent.component'
import CarpayOrderCardHeader from '../CarpayOrderCardHeader.component'

const UnpaidCarpayOrderCard = ({
    order,
    discount,
    priceToBePaid,
    isLast,
    disabled,
    onClick,
    currency,
    paymentDeadline
}: SpecificCarpayCard) => {
    const { isLoggedIn } = useAuth()
    const { t } = useTranslation()
    const startDate = DateTime.fromISO(order.start_date)

    return (
        <ParkingCard isLast={isLast} disabled={disabled} onClick={onClick}>
            <CarpayOrderCardHeader
                text={startDate.toFormat('dd.MM.yyyy')}
                badgeText={t('carpay.orderStatuses.unpaid')}
                badgeVariant="warning"
            />

            <CarpayOrderCardContent
                title={t('carpay.orderCard.price')}
                subtitle={<Countdown paymentDeadline={paymentDeadline} />}
                price={priceToBePaid}
                discount={discount}
                currency={currency}
            />

            {!isLoggedIn && <CardExtraInfo>{t('carpay.orderCard.privacyInfo')}</CardExtraInfo>}
        </ParkingCard>
    )
}

export default UnpaidCarpayOrderCard
